import { FC, useCallback } from 'react';

export interface FormReloadIconButtonProps {
  className?: string;
  onClick?(): void;
}

export const FormReloadIconButton: FC<FormReloadIconButtonProps> = ({ onClick, className }) => {
  const onChange = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <button data-e2e="batch-reload-form-button" className={`${className} btn btn-sm btn-link`} onClick={onChange}>
      <i className="icon icon-sm">autorenew</i>
    </button>
  );
};
